import React from "react";

import Box from "@mui/material/Box";

import { getFileTypeMime } from "../../utils";

import iconVideo from "../../assets/img/video-icon.jpg";
import iconAudio from "../../assets/img/mp3-icon.jpg";
import icon3d from "../../assets/img/3d-icon.jpg";
import { useSelector } from "react-redux";

const CoverCreator = ({ path, fileType, fileName, cover }) => {
	const imageType = getFileTypeMime(fileType, fileName);
	const coverFile = useSelector((state) => state.tmpUpload.cover);

	return (
		<>
			{imageType === "image" && (
				<Box
					sx={{
						maxHeight: "310px",
						maxWidth: "100%",
					}}
					component="img"
					src={path + fileName}
					alt="upload file"
				/>
			)}
			{imageType === "video" && (
				<Box
					sx={{
						maxHeight: "310px",
						maxWidth: "100%",
					}}
					component="video"
					src={path + fileName}
					poster={
						cover
							? coverFile.name
								? `${process.env.REACT_APP_API_DO_URL}/${cover}`
								: `${path}${cover}`
							: iconVideo
					}
					autoplay
					controls
				/>
			)}
			{imageType === "3d" && (
				<Box
					sx={{
						maxHeight: "310px",
						maxWidth: "100%",
					}}
					component="img"
					src={
						cover
							? coverFile.name
								? `${process.env.REACT_APP_API_DO_URL}/${cover}`
								: `${path}${cover}`
							: icon3d
					}
				/>
			)}
			{imageType === "audio" && (
				<Box
					sx={[
						{
							width: "100%",
							minWidth: "310px",
							textAlign: "center",
						},
					]}
					component="figure"
				>
					<Box
						component="img"
						src={
							cover
								? coverFile.name
									? `${process.env.REACT_APP_API_DO_URL}/${cover}`
									: `${path}${cover}`
								: iconAudio
						}
						sx={{
							maxWidth: "100%",
							maxHeight: "310px",
							pb: "1rem",
						}}
					/>
					<div>
						<audio controls src={path + fileName}>
							Your browser does not support the
							<code>audio</code> element.
						</audio>
					</div>
				</Box>
			)}
		</>
	);
};

export default CoverCreator;
